var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/join-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-a43b63ac!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/join-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/JoinEdit.vue
// module id = 635
// module chunks = 1